import createTradePlanCopy from '../../../../../../../../classes/tradePlan/createTradePlanCopy';
import { submitTradePlan } from './submitTradePlan';

export function GetErrorMessage({
  direction,
  setup,
  currentPrice,
  price,
}) {
  let result = {
    status: true,
    message: 'Success',
  }
  let aboveBelow = ''
  let directionTxt = 'direction'
  if( setup === 'BREAK' || setup === 'BOUNCE') {
    aboveBelow = price < currentPrice ? 'below' : 'above'
  }
  if( directionTxt === 'NONE' || directionTxt === 'BOTH' ) {
    // TODO is this right?
    return result
  }
  let msg = `Cannot ${setup.toLowerCase()} ${direction.toLowerCase()} from ${aboveBelow} current price`;
  result.status = false
  result.message = msg
  return result
}
